import { gql } from '@apollo/client';

import { GQL_TAG_FRAGMENT } from '../../../activity/graphql/fragments';

export const GQL_GET_PROJECT_TAGS = gql`
  query GetProjectTags($id: ID!) {
    viewer {
      id
      project(id: $id) {
        id
        photoTags {
          nodes {
            ...TagFragment
          }
        }
        videoTags {
          nodes {
            ...TagFragment
          }
        }
      }
    }
  }

  ${GQL_TAG_FRAGMENT}
`;
